import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../../constants/BusinessObjectivesTranslationKeys';
import ProductIcon from '../../common/ProductIcon';
import { Section } from '../MerchCardSharedComponents';
import SuiteBusinessObjectivesSubtext from './SuiteBusinessObjectivesSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SuiteBusinessObjectives = ({
  productLevel,
  commonStyles
}) => {
  const DisplayedProductLines = AllCombinedProductLines;

  // In order for the grid to work, we need this to remain enclosed in a Fragment and not a div.
  // Children of the display grid item must get the grid-start attributes directly
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      className: "p-top-8",
      style: Object.assign({
        gridRowStart: 8
      }, commonStyles),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6",
      style: Object.assign({
        gridRowStart: 9,
        lineHeight: 'normal',
        fontSize: '14px'
      }, commonStyles),
      children: /*#__PURE__*/_jsx(UIList, {
        children: DisplayedProductLines.map(localProductLine => {
          return /*#__PURE__*/_jsxs(UIFlex, {
            className: "m-y-3",
            align: "center",
            children: [/*#__PURE__*/_jsx(ProductIcon, {
              className: "display-inline m-right-3",
              productLine: localProductLine,
              style: {
                height: '32px'
              }
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                style: productLevel !== FREE ? {
                  fontWeight: 500
                } : {},
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
                })
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
                  productLevel: productLevel,
                  productLine: localProductLine
                })
              })]
            })]
          }, localProductLine);
        })
      })
    })]
  });
};
export default SuiteBusinessObjectives;